import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_RECENT_SEARCHES
`,
    {
        prefix: 'search/'
    }
);
